(() => {
  if (customElements.get("featured-articles")) {
    return;
  }

  class FeaturedArticles extends HTMLElement {
    constructor() {
      super();

      this.slider = {};
    }

    connectedCallback() {
      this.slider = new Splide(this.querySelector("[data-slider]"), {
        pagination: false,
        rewind: false,
        waitForTransition: false,
        flickMaxPages: 0.5,
        arrows: false,
        gap: "48px",
        fixedWidth: "351px",
        autoHeight: true,
        breakpoints: {
          990: {
            arrows: false,
            gap: "24px",
            fixedWidth: "244px",
          },
        },
      }).mount();
    }
  }

  customElements.define("featured-articles", FeaturedArticles);
})();
